function initTicket() {
  window.onerror = (message, source, lineno, colno, error) => {
    const errorDetails = {
      type: "jsError",
      message: message,
      source: source,
      line: lineno,
      column: colno,
      stack: error ? error.stack : null,
    };
    BUGS.errors.push(errorDetails);
    // console.error(errorDetails);
    return true; // Empêche l'affichage dans la console par défaut
  };

  // Capture des erreurs de promesse non gérées
  window.addEventListener("unhandledrejection", (event) => {
    const errorDetails = {
      type: "promiseError",
      message: event.reason?.message || event.reason,
      stack: event.reason?.stack || null,
    };
    BUGS.errors.push(errorDetails);
    // console.error(errorDetails);
  });

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    try {
      const response = await originalFetch.apply(window, args);

      if (!response.ok && response.status >= 500) {
        const errorDetails = {
          type: "networkError",
          url: response.url,
          status: response.status,
          statusText: response.statusText,
        };
        BUGS.errors.push(errorDetails);
        // console.error(errorDetails);
      }
      return response;
    } catch (error) {
      const errorDetails = {
        type: "networkError",
        message: error.message,
        stack: error.stack || null,
      };
      BUGS.errors.push(errorDetails);
      // console.error(errorDetails);
      throw error;
    }
  };

  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Enregistre l'erreur dans errorLog
    BUGS.errors.push({
      type: "consoleError",
      message: args
        .map((arg) => (arg instanceof Error ? arg.message : arg))
        .join(" "),
      stack: args.find((arg) => arg instanceof Error)?.stack || null,
    });

    // Appelle l'implémentation de `console.error` d'origine
    originalConsoleError.apply(console, args);
  };
}

export default initTicket;
